const getCurrentInput = (input) => {
    if (input?.rows && Array.isArray(input?.rows)) {
        return input?.rows.reduce(
            (acc, currentRow) => [
                ...acc,
                ...(currentRow?.columns ? currentRow.columns : [currentRow]),
            ],
            [],
        );
    }

    if (input?.columns && Array.isArray(input?.columns)) {
        return input?.columns.reduce((acc, currentColumn) => [...acc, currentColumn], []);
    }
    return input;
};

const getInputs = (inputs) =>
    inputs?.reduce((accumulator, currentValue) => {
        const newInput = getCurrentInput(currentValue);
        return [...accumulator, ...(Array.isArray(newInput) ? newInput : [newInput])];
    }, []);

export default getInputs;
